module.exports = __webpack_public_path__ + "static/img/06.80c3b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/06.png
// module id = tQOd
// module chunks = 0